// Gravités d'un signalement (DS §6.16) — SANS zod : `SignalerProbleme` en a
// besoin de façon SYNCHRONE (le fieldset des 3 choix est toujours affiché dès
// l'ouverture du dialogue), et zod ne doit pas alourdir son chunk pour ça.
// `schema.ts` ré-exporte ces mêmes valeurs pour la validation (zod, elle,
// n'est chargée qu'au moment de l'envoi — cf. `envoyer.ts`, importé
// dynamiquement par `SignalerProbleme`).

export const GRAVITES = ["bloque", "contournable", "detail"] as const;
export type Gravite = (typeof GRAVITES)[number];

export const GRAVITE_LIBELLES: Record<Gravite, string> = {
  bloque: "Je suis bloqué·e, je ne peux pas finir",
  contournable: "Je peux contourner, mais c'est gênant",
  detail: "Détail ou suggestion",
};
